import { useEffect, useState } from "react";

// 00:17:34 — restarts automatically when it reaches zero. Shared start so every timer on the page stays in sync.
const DURATION = 17 * 60 + 34;
const START = Date.now();

function getRemaining() {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION - (elapsed % DURATION);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  return {
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
  };
}
